import { api } from "../../../infra/api";
import { Paginate } from "../../../infra/paginate";
import { URLS } from "../../../infra/URLS";
import { NotaFiscalType } from "../types";

export default async function getNotasFiscais(search?: string, page = 1) {
  const { data } = await api.get<Paginate<NotaFiscalType>>(
    `${URLS.NOTA_FISCAL_API}`, {
      params: {page, search}
    });

  return data;
}

export async function getNotaFiscal(notaFiscalId: any) {
  const result = await api.get(`${URLS.NOTA_FISCAL_API}/${notaFiscalId}`)
  .then((resp => resp.data));
  return result;
}


export async function getAllNotaFiscal(search?: string) {
  const size = await api
    .get(`${URLS.NOTA_FISCAL_API}`)
    .then((resp) => resp.data.meta);

  const resultJson = await api
    .get(
      `${URLS.NOTA_FISCAL_API}?${search ? "search" : "limit"}=${
        search ? search : size.totalItems
      }`
    )
    .then((resp) => resp.data.items);

  return resultJson;
}
